<template>
  <div class="user-info">
    <div class="title">Token expires in</div>
    <div class="refresh-token-block">
      <vue-timepicker
        input-class="duration-picker-input"
        input-width="92px"
        format="HH:mm:ss"
        v-model="expObj"
      />
      <span class="secondary-button" @click="onUpdateClick">
        Update token
      </span>
    </div>
    <div class="user-name">
      You are signed as <span @click="copyUserId">{{ username }}</span>
    </div>
    <span class="secondary-button logout" @click="logout">Sign Out</span>
  </div>
</template>

<script>
import { mapState } from "vuex";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import CtaButton from "./header/CtaButton.vue";

const emulateCopy = str => {
  if (document.getSelection().toString()) return;

  const el = document.createElement("textarea");
  el.value = str;
  el.readOnly = true;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
};

export default {
  name: "UserInfo",
  components: {
    VueTimepicker,
    CtaButton
  },
  computed: {
    ...mapState("balance", ["amount"]),
    ...mapState("auth", ["username", "currency", "userId"])
  },
  data() {
    return {
      expObj: {
        HH: "00",
        mm: "00",
        ss: "10"
      }
    };
  },
  methods: {
    copyUserId() {
      emulateCopy(this.userId);
    },
    logout() {
      this.$store.dispatch("auth/logout");
    },
    onUpdateClick() {
      this.$store.dispatch(
        "auth/updateToken",
        {
          ttl: Math.round(Number(this.expObj.ss) + Number(this.expObj.mm) * 60 + Number(this.expObj.HH * 3600))
        }
      );
    }
  }
};
</script>

<style scoped>
.title {
  font-size: 12px;
  line-height: 1.5;
  font-weight: 600;
  margin: 0 0 8px 8px;
  color: #3b4c58;
  text-align: start;
}
.user-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}

.user-name {
  font-size: 12px;
  line-height: 15px;
}

.refresh-token-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}

.logout {
  margin-top: 20px;
}

.secondary-button {
  cursor: pointer;
  text-decoration: none;
  color: #0821ff;
}
.secondary-button:hover {
  text-decoration: underline;
}
</style>

<style>
.duration-picker-input {
  height: 32px !important;
  padding-left: 8px !important;
  padding-right: 8px !important;
  color: #000;
  font-weight: bold;
  border: 1px solid #eaeaea !important;
  border-radius: 4px;
}
.vue__time-picker .clear-btn {
  padding-left: 8px;
  padding-right: 8px;
}

.vue__time-picker .dropdown ul li:not([disabled]).active {
  background: #0821ff;
}
.vue__time-picker .dropdown ul li:not([disabled]).active:hover {
  background: #085cff;
}
</style>
